import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import React, { useEffect, useState } from 'react';
import { Row, Col, CardBody, Card, Alert, Container } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { apiEndpoint } from 'helpers/url_helper';
import jwt from 'jsonwebtoken';
import logoDark from '../../assets/images/Logo.png';
import { withRouter, Link } from "react-router-dom";

const Login = (props) => {
  const [error, setError] = useState('');
  const [errorColor, setErrorColor] = useState('');
  const [otpVisible, setOtpVisible] = useState(false);
  const [sendOtpDisabled, setSendOtpDisabled] = useState(false);
  const [otp, setOtp] = useState('');
  const [timer, setTimer] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [loginButtonVisible, setLoginButtonVisible] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSendOtp = () => {
    setOtpVisible(true);
    setSendOtpDisabled(true);
    setLoginButtonVisible(true);
    setCountdown(120);

    fetch(apiEndpoint + '/Login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        UserName: username,
        Password: password,
      }),
    })
      .then((res) => res.json())
      .then(
        (response) => {
          if (response.status) {
            setError(response.message);
            setErrorColor('success');
          } else {
            setError(response.message);
            setErrorColor('danger');

            setSendOtpDisabled(false);
            setOtpVisible(false);
            setLoginButtonVisible(false);
          }
        },
        (error) => {
          setError('An unexpected error occurred.');
          setErrorColor('danger');
        }
      );

    const intervalId = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(intervalId);
          setSendOtpDisabled(false);
          setOtpVisible(false);
          setLoginButtonVisible(false);
          setOtp('');
          setError(null);
          setErrorColor(null);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    setTimer(intervalId);
  };

  const handleValidSubmit = (event, values) => {
    fetch(apiEndpoint + '/Login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        UserName: values.username,
        Password: values.password,
        OTP: otp,
      }),
    })
      .then((res) => res.json())
      .then(
        (response) => {
          if (response.status) {
            if (response.token) {
              const cleanToken = response.token.replace(/^"+|"+$/g, '');
              const decodedToken = jwt.decode(cleanToken);
              sessionStorage.setItem('userFullName', decodedToken.userFullName);
              sessionStorage.setItem('Clear_AuthUser', cleanToken);

              const secretKey = 'ToEncodePasswordChange';
              const encodedPasswordChange = jwt.sign(response.needsPasswordChange,secretKey);

              sessionStorage.setItem('GetToChange', encodedPasswordChange);
              
              // Check if password change is required
              if (response.needsPasswordChange) {
                props.history.push('/defaultPasswordChange');
              } else {
                props.history.push('/dashboard');
              }
            } else {
              setError('Invalid token or missing userRolePermissions');
              setErrorColor('danger');
            }
          } else {
            setError(response.message);
            setErrorColor('danger');
          }
        },
        (error) => {
          setError('An unexpected error occurred.');
          setErrorColor('danger');
        }
      );
  };

  const onFormSubmit = (event, values) => {
    if (event.nativeEvent.submitter.name === 'sendOtp') {
      handleSendOtp();
    } else {
      handleValidSubmit(event, values);
    }
  };

  useEffect(() => {
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [timer]);

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login</title>
      </MetaTags>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link className="d-block auth-logo">
                      <img src={logoDark} alt="" height="60" className="auth-logo-dark" />
                    </Link>
                  </h3>
                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">Welcome Back!</h4>
                    <p className="text-muted text-center">Sign in to continue to Indus.</p>
                    <AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={onFormSubmit}
                    >
                      {error && typeof error === 'string' ? (
                        <Alert color={errorColor}>{error}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <AvField
                          name="username"
                          label="Username"
                          className="form-control"
                          placeholder="Enter Username"
                          onChange={(e) => setUsername(e.target.value)}
                          disabled={sendOtpDisabled}
                          type="text"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          type="password"
                          required
                          placeholder="Enter Password"
                          onChange={(e) => setPassword(e.target.value)}
                          disabled={sendOtpDisabled}
                        />
                      </div>

                      {otpVisible && (
                        <div className="mb-3">
                          <AvField
                            name="otp"
                            label="OTP"
                            type="text"
                            placeholder="Enter OTP"
                            onChange={(e) => setOtp(e.target.value)}
                            required
                          />
                        </div>
                      )}

                      <div className="mb-3 row mt-4">
                        <div className="col-6">
                          <button
                            name="sendOtp"
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            disabled={sendOtpDisabled}
                          >
                            {sendOtpDisabled ? `Resend in ${countdown}s` : 'Send OTP'}
                          </button>
                        </div>
                        {loginButtonVisible && (
                          <div className="col-6 text-end">
                            <button
                              name="login"
                              className="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                            >
                              Log In
                            </button>
                          </div>
                        )}
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} <span className="d-none d-sm-inline-block">Ador Powertron Ltd </span>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
};

export default withRouter(Login);
